import React, { useMemo, useEffect } from 'react';
import { Breadcrumb, } from '@sas/nova-commons/components/Breadcrumb';
import { BreadcrumbState as BirdBreadcrumbState, } from '../../store/breadcrumb/BreadcrumbState';
import { BirdLayoutState } from '../../store/birdLayout/BirdLayoutState';
import { useI18n } from '../../locale/I18nContext';
import { connect } from 'react-redux';
import { selectBirdBreadcrumbState, selectStyleState, selectWarningState, } from '../../store/selectors';
import { bindActionCreators } from 'redux';
import { fontStyles, textHeight } from '../utils/style';
import { useDesignTokens } from '@sas/nova-commons/theme';
import { useFontLoadedKey } from '../FontProvider';
export const BirdBreadcrumbAreaBase = ({ id, style, breadcrumbs, setBreadcumbLayout, breadcrumbActions, warningState, }) => {
    const dt = useDesignTokens();
    const fonts = useMemo(() => fontStyles(style === null || style === void 0 ? void 0 : style.font, dt), [style === null || style === void 0 ? void 0 : style.font, dt]);
    const fontKey = useFontLoadedKey(fonts.fontFamily);
    const renderedBreadcrumbCount = breadcrumbs.reduce((total, value) => total + (value.items.length > 0 ? 1 : 0), 0);
    useEffect(() => {
        const breadcrumbHeight = Math.max(28 /* min height 1.75rem */, textHeight(fonts) + 8 /* padding */ + 2 /* border */);
        setBreadcumbLayout(id, { height: renderedBreadcrumbCount * breadcrumbHeight });
    }, [fontKey /*(implicit)*/, renderedBreadcrumbCount, setBreadcumbLayout, id, fonts]);
    const visualHasError = warningState.type === 'error';
    return !visualHasError && breadcrumbs.length ? (React.createElement("div", null, breadcrumbs.map((data) => (React.createElement(BirdBreadcrumb, Object.assign({ id: id }, data, { actions: breadcrumbActions, key: data.name, tokens: () => {
            var _a, _b;
            return ({
                fg: (_a = style === null || style === void 0 ? void 0 : style.normal) === null || _a === void 0 ? void 0 : _a.fg,
                fontFamily: (_b = style === null || style === void 0 ? void 0 : style.font) === null || _b === void 0 ? void 0 : _b.fontFamily,
            });
        } })))))) : null;
};
export const BirdBreadcrumbArea = connect((state, props) => ({
    style: selectStyleState(state, props.id),
    breadcrumbs: selectBirdBreadcrumbState(state, props.id),
    warningState: selectWarningState(state, props.id),
}), (dispatch) => ({
    setBreadcumbLayout: bindActionCreators(BirdLayoutState.actions.setBreadcumbLayout, dispatch),
    breadcrumbActions: bindActionCreators(BirdBreadcrumbState.actions, dispatch),
}))(BirdBreadcrumbAreaBase);
const BirdBreadcrumb = ({ id, items, name, label, actions, tokens }) => {
    // Use the label as an additional first item
    const localize = useI18n();
    const firstValue = useMemo(() => ({ values: [localize(label)], selectedIndex: 0, isSingle: true }), [localize, label]);
    const values = useMemo(() => [firstValue, ...(items || [])], [
        firstValue,
        items,
    ]);
    return items.length ? (React.createElement(Breadcrumb, { tokens: tokens, orientation: "AUTO", values: values, selectCrumb: (index) => {
            actions.selectBreadcrumb(id, { name, index: index - 1 });
        }, openCrumb: (index) => {
            actions.openBreadcrumb(id, { name, index: index - 1 });
        }, selectCrumbValue: (index, valueIndex) => {
            actions.selectBreadcrumbItem(id, { name, index: index - 1, valueIndex });
        } })) : null;
};
